import { BaseEntity } from "yt-ng-framework";

export class BankaView extends BaseEntity{
    constructor(){
        super();
    }

    Sifra: string = null;
    Naziv: string = null;
    Adresa: string = null;
    Mesto: string = null;

    Deserialize(input: any){
        this.ID=input.ID;
        this.Sifra=input.Sifra;
        this.Naziv=input.Naziv;
        this.Adresa=input.Adresa;
        this.Mesto=input.Mesto;
        return this;
    }

    Serialize(input:BankaView){
        return input;
    }
}